import Img2023_1 from '../img/jury/data7 img2023_1.png'
import Img2023_2 from '../img/jury/data7 img2023_2.png'
import Img2023_3 from '../img/jury/data7 img2023_3.png'
import Img2022_1 from '../img/jury/data7 img2022_1.png'
import Img2022_2 from '../img/jury/data7 img2022_2.png'
import Img2022_3 from '../img/jury/data7 img2022_3.png'
import Img2021_1 from '../img/jury/data7 img2021_1.png'
import Img2021_2 from '../img/jury/data7 img2021_2.png'
import Img2021_3 from '../img/jury/data7 img2021_3.png'
import Img2020_1 from '../img/jury/data7 img2020_1.png'
import Img2020_2 from '../img/jury/data7 img2020_2.png'
import Img2020_3 from '../img/jury/data7 img2020_3.png'

const data7 = [
    {
      year: 2023,
      items: [
        {
          name: 'Елена Шумилова',
          country: 'Украина',
          image: Img2023_1,
          text1: 'Детский и семейный фотограф с международной известностью',
          text2: 'Участник жюри фотоконкурсов и спикер фотофестивалей в Европе, России и США',
          text3: 'Работы Елены экспонировались на многих групповых, а также на нескольких персональных выставках - России, Бельгии и Японии',
          text4: 'Главным источником идей и вдохновения для Елены становятся ностальгические воспоминания о детстве',
          text5: 'С 2015 года провела более 100 мастер-классов разных странах мира от Исландии до Австралии',
        },
        {
            name: 'Гоша Камаев',
            country: 'Россия',
          image: Img2023_2,
          text1: 'Самый популярный и востребованный у блогеров фотограф',
          text2: 'Его фотографии наполняют аккаунты самых крупных инста-блогеров России',
          text3: '17 лет опыта в коммерческой фотографии и работа в разных жанрах',
          text4: 'Динамичные фотографии, наполненные жизнью и чувственностью кадры',
          text5: 'Дает практические советы по съёмке, продвижению и саморазвитию',
        },
        {
            name: 'Ирина Недялкова',
            country: 'Беларусь',
          image: Img2023_3,
          text1: 'Топовый семейный и детский фотограф',
          text2: 'Мировую известность Ирина получила благодаря серии с пожилой парой, сделанной на Финском заливе',
          text3: 'Популярность Ирины подтверждена многочисленными мастер-классами',
          text4: 'Спикер фотофестивалей SUMMERFOTOFEST, WINTERFOTOFEST, Euroasianphotofestival',
          text5: 'Человек-мотиватор, лайфкоуч, вдохновляющая на перемены личным примером',
        },
      ],
    },
    {
        year: 2022,
        items: [
          {
            name: 'Ольга Папина',
            country: 'Россия',
            image: Img2022_1,
            text1: 'Cпециализируется на съемке Таинство Крещения и Венчания',
            text2: 'Член союза фотохудожников России',
            text3: 'Победитель Bicfp 2016 и 2017 гг. в номинации Таинство крещения (1 место)',
            text4: 'Лучшее фото май 2017 по версии Nikon',
            text5: 'Организатор сообщества “Союз церковных фотографов”, а также международных православных выставок и фотоконкурсов церковных фотографов',
          },
          {
            name: 'Ирина Калмыкова',
            country: 'Россия',
            image: Img2022_2,
            text1: 'Один из самых известных в России детских фотографов',
            text2: 'Обладательница Гран-при и звания «Фотограф года-2015» по версии',
            text3: 'Международной Премии BICFP, организованной при поддержке Правительства РФ',
            text4: 'Призёр BICFP-2013 и BICFP-2014',
            text5: 'На данный момент Ирина активно проводит мастер-классы в России, Франции, Англии и странах ближнего зарубежья',
          },
          {
            name: 'Алёна Гороховская',
            country: 'Россия',
            image: Img2022_3,
            text1: 'Топовый фотограф новорожденных в России',
            text2: 'За плечами Алёны сотни последователей по всей России и за ее пределами',
            text3: 'Основатель первой специализированной студии для новорожденных в Санкт-Петербурге',
            text4: 'Основатель онлайн-курса для newborn-фотографов Перезагрузка',
            text5: 'Автор уникального обучающего приложения для фотографов baby art photo',
          },
        ],
      },
      {
        year: 2021,
        items: [
          {
            name: 'Наталия Козлова',
            country: 'Россия',
          image: Img2021_1,
          text1: 'Член Гильдии неигрового кино и телевидения, Гильдии фотографов России',
          text2: 'Более 20 лет преподавала режиссуру экранных искусств в Российском государственном институте сценических искусств',
          text3: 'Санкт-Петербургском гуманитарном университете профсоюзов 10 лет опыта работы в кино',
          text4: 'С 2002 года создает и проводит авторские мастер-классы для фотографов, режиссёров, видеографов',
          text5: 'Спикер Winterfotofest International — 2019',
        },
          {
            name: 'Аня Соул',
            country: 'Украина',
            image: Img2021_2,
            text1: 'Топовый фотограф беременности в стиле Минимализм',
            text2: 'TOP-100 главной всероссийской премии в области фотографии',
            text3: 'Russian Photo Awards 2021-2022 в номинации Беременность',
            text4: 'TOP-50 фотографов беременности в мире по версии 35AWARDS 2018',
            text5: 'Участница фотовыставки MFamilia «Цвет»',
          },
          {
            name: 'Екатерина Штерн',
            country: 'Россия',
            image: Img2021_3,
            text1: 'Топовый семейный и детский фотограф, работающий в сегменте Premium с 14-летним стажем',
            text2: 'Лидер Ассоциации детских и семейных фотографов, призер ежегодной международной премии детских и семейных фотографов BICF',
            text3: 'Провела более 150 мастер-классов для фотографов во всех уголках России, в Европе, странах СНГ и Азии',
            text4: 'Спикер крупных фотоконференций и фотофестивалей в Азии и России (SUMMERFOTOFEST, WINTERFOTOFEST и тд)',
            text5: 'Входит в TOP 2% фотографов в жанре детский портрет по версии 35PHOTO',
          },
        ],
      },
      {
        year: 2020,
        items: [
          {
            name: 'Кемран Ширалиев',
            country: 'Россия',
            image: Img2020_1,
            text1: 'Лучший свадебный фотограф по версии ISPWP',
            text2: 'ТОП-10 лучших фотографов Fearless',
            text3: 'Фотограф года по версии XP Photographers Финалист Wedding Award Russ',
            text4: 'Победитель Russian Photo Awards 2023',
            text5: 'Активно снимает и обучает фотографии',
          },
          {
            name: 'Алексей Малышев',
            country: 'Россия',
            image: Img2020_2,
            text1: 'ТОП свадебных фотографов Москвы, россии и мира по версии Mywed.com',
            text2: 'ТОП-30 лучших свадебных фотографов в мире по версии международной ассоциацииFearlessphotographers в 2015',
            text3: 'Вошёл в список "Свадебный репортаж: 20 лучших фотографов в Москве" по версии ZANKYOU',
            text4: 'Вошёл в список "ТОП16 свадебных фотографов, снимающих и за границей!" по версии ZANKYOU',
            text5: 'Финалист Mywed Award 2014-2019',
          },
          {
            name: 'Валентина Осинцева',
            country: 'Россия',
            image: Img2020_3,
            text1: '13 лет коммерчески успешный фотограф',
            text2: 'Создатель масштабного фотокурса для родителей и семейных фотографов «Дети в фокусе»',
            text3: 'Развивает популярность семейной фотографии в России',
            text4: 'Проводит мастер-классы и учит не только фотографировать, но и зарабатывать на фотографии',
            text5: 'Ей доверяют фотографировать своих детей известные блогеры',
          },
        ],
      },
      {
        year: 2019,
        items: [
            {
                name: 'Алексей Малышев',
                country: 'Россия',
                image: Img2020_2,
                text1: 'ТОП свадебных фотографов Москвы, россии и мира по версии Mywed.com',
                text2: 'ТОП-30 лучших свадебных фотографов в мире по версии международной ассоциацииFearlessphotographers в 2015',
                text3: 'Вошёл в список "Свадебный репортаж: 20 лучших фотографов в Москве" по версии ZANKYOU',
                text4: 'Вошёл в список "ТОП16 свадебных фотографов, снимающих и за границей!" по версии ZANKYOU',
                text5: 'Финалист Mywed Award 2014-2019',
              },
              {
                name: 'Ольга Папина',
                country: 'Россия',
                image: Img2022_1,
                text1: 'Cпециализируется на съемке Таинство Крещения и Венчания',
                text2: 'Член союза фотохудожников России',
                text3: 'Победитель Bicfp 2016 и 2017 гг. в номинации Таинство крещения (1 место)',
                text4: 'Лучшее фото май 2017 по версии Nikon',
                text5: 'Организатор сообщества “Союз церковных фотографов”, а также международных православных выставок и фотоконкурсов церковных фотографов',
              },
              {
                name: 'Екатерина Штерн',
                country: 'Россия',
                image: Img2021_3,
                text1: 'Топовый семейный и детский фотограф, работающий в сегменте Premium с 14-летним стажем',
                text2: 'Лидер Ассоциации детских и семейных фотографов, призер ежегодной международной премии детских и семейных фотографов BICF',
                text3: 'Провела более 150 мастер-классов для фотографов во всех уголках России, в Европе, странах СНГ и Азии',
                text4: 'Спикер крупных фотоконференций и фотофестивалей в Азии и России (SUMMERFOTOFEST, WINTERFOTOFEST и тд)',
                text5: 'Входит в TOP 2% фотографов в жанре детский портрет по версии 35PHOTO',
              },
        ],
      },
  ];

  export default data7;
